import React from "react";
import Div from "../../../widget/common/ui/Div";
import AppTranslation from "../../../service/app_translation/AppTranslation";

const DeactivateAccountContent = (props: { type?: number | undefined }) => {

  return (
    <Div className="pt-4">
      <div
        className="font-size-16_17 font-gotham-book color-theme-label"
        dangerouslySetInnerHTML={{
          __html: AppTranslation.text("deactivate_agreement_text").replaceAll(
            "\n",
            "<br />"
          ),
        }}
      />
      <div
        className="font-size-16_17 font-gotham-bold pt-4 color-red2"
        dangerouslySetInnerHTML={{
          __html: AppTranslation.text(
            "are_you_sure_you_wish_to_delete_this_account"
          ).replaceAll("\n", "<br />"),
        }}
      />
    </Div>
  );
};

export default DeactivateAccountContent;
